<template lang="html">
  <div class="reviews__container">
    <TryForFreeSection
      :feature-name="$t('pages.reviews.try_for_free.feature_name')"
      :title="$t('pages.reviews.try_for_free.title')"
      :description="$t('pages.reviews.try_for_free.description')"
      image-path="/images/features/reviews/try_for_free_section_illustration.png"
    />
    <FeaturedReviews />
    <StatsSection />
    <UserReviews />
    <MoveYourPodcastSection />
  </div>
</template>

<script>
import getMeta from '@/lib/meta'
import { schemaMarkup } from '@/lib/reviews/schema-markup'
import TryForFreeSection from '@/components/pages/features/common/try-for-free/index'
import FeaturedReviews from '@/components/pages/reviews/featured-reviews/index'
import MoveYourPodcastSection from '@/components/pages/features/common/move-your-podcast/index'
import StatsSection from '@/components/pages/reviews/stats/index'
import UserReviews from '@/components/pages/reviews/user-reviews/index'

export default {
  components: {
    TryForFreeSection,
    FeaturedReviews,
    UserReviews,
    MoveYourPodcastSection,
    StatsSection
  },

  layout: 'landing',

  middleware: ['languageRedirect'],

  head () {
    const resultMeta = getMeta({
      title: this.$t('meta.ssr_reviews.title'),
      metaTitle: this.$t('meta.ssr_reviews.title'),
      description: this.$t('meta.ssr_reviews.description'),
      route: this.$route,
      i18nLocales: this.$i18n.locales,
      i18nSeo: this.$nuxtI18nSeo(),
      options: {
        gdpr: this.$store.state.auth.gdprThirdParty
      }
    })

    resultMeta.script.push({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schemaMarkup)
    })

    return resultMeta
  }
}
</script>

<style lang="scss" scoped>
.reviews {
  &__container {
    padding-bottom: $gap * 11;
  }
}
</style>
